<template>
  <div class="center">
    <div class="title">
      You left the meeting
    </div>
    <div class="actions">
      <b-btn
        variant="secondary-light"
        @click="rejoin">Rejoin
      </b-btn>
    </div>
    <div class="footer clearfix">
      <div class="float-left"><small>© {{ new Date().getFullYear() + " " + $t('LOGIN.COPYRIGHTS') }}</small></div>
      <div class="float-right"><a
        target="_blank"
        href="https://www.corenexa.com/privacy-policy">{{ $t('LOGIN.PRIVACY_POLICY') }}</a></div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'ExitMeeting',
  setup(props, context) {

    function rejoin() {
      window.open(context.root.$route.params.url,"_self")
    }

    return {
      rejoin
    }
  }
}
</script>
<style>

.center {
  background-color: #ffffff;
  flex-flow: column;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100vw;
  height: 100vh;
}

.center .title {
  font-size: 1.6em;
  color: #000000;
}

.center .actions {
  margin-top: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/ExitMeeting.vue